/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decode`)
};

const es_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificar`)
};

const de_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dekodieren`)
};

const nl_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decoderen`)
};

const fr_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décoder`)
};

const it_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodifica`)
};

const pt_br2_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificar`)
};

const pt_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descodificar`)
};

const ja_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デコード`)
};

const zh_ue_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解码`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_mode_decode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_mode_decode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_mode_decode", locale)
	if (locale === "en") return en_ue_mode_decode(inputs)
	if (locale === "es") return es_ue_mode_decode(inputs)
	if (locale === "de") return de_ue_mode_decode(inputs)
	if (locale === "nl") return nl_ue_mode_decode(inputs)
	if (locale === "fr") return fr_ue_mode_decode(inputs)
	if (locale === "it") return it_ue_mode_decode(inputs)
	if (locale === "pt-BR") return pt_br2_ue_mode_decode(inputs)
	if (locale === "pt") return pt_ue_mode_decode(inputs)
	if (locale === "ja") return ja_ue_mode_decode(inputs)
	return zh_ue_mode_decode(inputs)
};